import { createFileRoute, redirect } from "@tanstack/react-router";

import { authQueries } from "@/api/resources/auth/queries";
import LoginSSOPage from "@/components/Login/LoginSSOPage";

export const Route = createFileRoute("/login-sso")({
  validateSearch: (search) =>
    search as {
      redirect?: string;
    },
  beforeLoad: async ({ context }) => {
    // redirect to index page (currentWorkspace determination) if claims exists
    const claims = await context.queryClient.fetchQuery(authQueries.getAuthClaims());
    if (claims) {
      throw redirect({
        to: "/",
      });
    }
  },
  component: LoginSSOPage,
});
